import Lightbox from "./modules/Lightbox";

new Lightbox();
